import {RegulationComponentsCommon} from "../../regulation-components-common";
import {AboutComponentProps} from "../../../../components/about-component/about.component";
import React from "react";
import {SwedenMinimumGamblingAgeComponent} from "../../../../components/responsible-gambling/minimum-gambling-age/regulations/sweden/sweden.minimum-gambling-age.component";
import {SwedenResponsibleGamingButtonsComponent} from "../../../../components/responsible-gambling/responsible-gaming-buttons/regulations/sweden/sweden.responsible-gaming-buttons.component";

export class SwedenRegulationComponents extends RegulationComponentsCommon {
    protected async _getAboutDialogProps(): Promise<AboutComponentProps> {
        const props = await super._getAboutDialogProps();
        const sessionBalance = await this.services.user.getOpenSessionsRealMoneyBalance();
        return {
            ...props,
            openSessionsBalance: sessionBalance
        };
    }

    renderHeaderMinimumGamblingAge() {
        return(<SwedenMinimumGamblingAgeComponent isShownInHeader={true}/>);
    }

    renderHeaderRegulationIcons() {
        return (
            <SwedenResponsibleGamingButtonsComponent useIconsOnly={false} isShownInHeader={true}/>
        );
    }
}